import { Tab, Tabs } from '@mui/material';
import { TabsControls } from 'src/types/TabsControls';
import { GridComponent } from './GridComponent';
import { TabPanel } from './TabPanel';

export const TabsControl: React.FC<TabsControls> = props => {
  return (
    <GridComponent {...props.gridParent} sx={{ background: 'white' }}>
      <GridComponent {...props.gridTabs}>
        <Tabs {...props.tabsProps} value={props.value}>
          {props.tabs.map(tabItem => (
            <Tab {...props.tabProps} key={`${tabItem.key}-${tabItem.index}`} label={props.tabsLabels[tabItem.key]} />
          ))}
        </Tabs>
      </GridComponent>
      <GridComponent {...props.gridTabsControlContainer}>
        {props.tabs.map(tabItem => (
          <TabPanel index={tabItem.index} value={props.value} key={tabItem.index}>
            <tabItem.component index={tabItem.index} />
          </TabPanel>
        ))}
      </GridComponent>
    </GridComponent>
  );
};
